import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import StatefulMultiSelect from "@khanacademy/react-multi-select";

export default class ProfitReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate:moment().toDate(),
            endDate:moment().toDate(),
            isLoading:false,
            getProfitReportUrl:'/api/v1/portal/portal-admin/profit-report',
            profitReportData:[],
            downloadReportName:'Job Price Report',
            selectedCustomers:[],
            customers:[],
            url: "/api/v1/portal/customers/all/for-dropdown-menu",
        };
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleCustomerSelection = this.handleCustomerSelection.bind(this);
    }
    componentDidMount() {
        let options = [];   
        return fetch(this.state.url, {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
        }).then((responseText) => {
          let response = responseText.json();
          response.then((response) => {
              response.map((customer)=>{
                options.push({
                    label : customer.company.short_name+'-'+customer.name,
                    value : customer.id
                });
            });
            this.setState({
              customers: options,
              isLoading: false
            });
          });
        });
    }
    handleStartDateChange(date) {
        this.setState({startDate: date})
    }
    handleEndDateChange(date) {
        this.setState({endDate: date})
    }
    handleCustomerSelection(selectedCustomers) {
        this.setState({selectedCustomers});
    }
    handleInvoicedJobsReportGeneration(e) {
        this.setState({isLoading: true});
        let url = this.state.getProfitReportUrl;
        return fetch(url, {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
          body: JSON.stringify({
            customer_ids: this.state.selectedCustomers,
            start_date:moment(this.state.startDate).format("YYYY-MM-DD"),
            end_date:moment(this.state.endDate).format("YYYY-MM-DD")
          }),
        }).then((responseText) => {
          let response = responseText.json();
          response.then((response) => {
            this.setState({
                profitReportData: response.jobs,
                isLoading: false
            })
          });
        });
    }
    download(filename, text) {
        filename = filename+' From '+moment(this.state.startDate).format("YYYY-MM-DD")+' To '+moment(this.state.endDate).format("YYYY-MM-DD")+'.csv';
        let element = document.createElement('a');
        element.setAttribute('href','data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      }
    render() {
        let profitedRecords = [];
        const {selectedCustomers} = this.state;
        let downloadableCsvDataInvoiced = "JOB REF,REG/VIN,CUSTOMER,STATUS,DRIVER COMPLETED DATE,JOB PRICE,ADMIN FEE,FUEL INCL,DRIVER PRICE,Fuel,Vehicle Movements,Toll Road,Waitingtime,Storage,Breakdown,Travel,Car Wash,Parts,Transport Services,Hotel,PROFIT,GROSS PROFIT %\n";
        if(this.state.profitReportData.length > 0){
            let jobTotals = 0.00;
            let adminTotals = 0.00;
            let driverTotals = 0.00;
            let expTotals = 0.00;
            let profitTotals = 0.00;
            let grossTotals = 0.00;
            let profitTotals_customer = 0.00;

            let expenses_approval_fuelTotal = 0.00;
            let vehicle_movementsTotal = 0.00;
            let toll_roadTotal = 0.00;
            let waitingtimeTotal = 0.00;
            let storageTotal = 0.00;
            let breakdownTotal = 0.00;
            let travelTotal = 0.00;
            let car_washTotal = 0.00;
            let partsTotal = 0.00;
            let transport_servicesTotal = 0.00;
            let hotelTotal = 0.00;
            let expense_price = 0.00;

            this.state.profitReportData.map((currentJob, index) => {
                let joburl = "/jobs/view/"+currentJob.id;

                let jobTotalPrice = parseFloat(currentJob.job_price);
                let dPrice = parseFloat(currentJob.driver_price);
                let ePrice = parseFloat(currentJob.expenses_price);
                let adminFPrice = (currentJob.admin_fee_in_pence) ? (parseFloat(currentJob.admin_fee_in_pence)) / 100 : 0.00;

                let fuel_price = parseFloat((currentJob.expenses_approval_fuel_total).toFixed(2));
                let vehicle_movements = parseFloat((currentJob.vehicle_movements/100).toFixed(2));
                let toll_road = parseFloat((currentJob.toll_road/100).toFixed(2));
                let waitingtime = parseFloat((currentJob.waitingtime/100).toFixed(2));
                let storage = parseFloat((currentJob.storage/100).toFixed(2));
                let breakdown = parseFloat((currentJob.breakdown/100).toFixed(2));
                let travel = parseFloat((currentJob.travel/100).toFixed(2));
                let car_wash = parseFloat((currentJob.car_wash/100).toFixed(2));
                let parts = parseFloat((currentJob.parts/100).toFixed(2));
                let transport_services = parseFloat((currentJob.transport_services/100).toFixed(2));
                let hotel = parseFloat((currentJob.hotel/100).toFixed(2));
                //even if fuel included in job price gemini still need to pay for it.
                if (currentJob.fuel_included_in_job_price === 1) {
                    expense_price = ((fuel_price) + (toll_road) + (travel) + (hotel));
                } else {
                    expense_price = ((toll_road) + (travel) + (hotel));
                }
                let jobProfitPlus = ((adminFPrice) + (dPrice) + (expense_price));
                let jobProfit = ((jobTotalPrice) - (jobProfitPlus));
                // let jobProfitPlus = ((adminFPrice) + (dPrice) + (parseFloat(currentJob.hotel)) + (parseFloat(currentJob.trael)) + (parseFloat(currentJob.toll_road)));
                // let profitTotals_cust = ((jobTotalPrice) - (jobProfitPlus));
                let expenses_approval_fuel_total = parseFloat(currentJob.expenses_approval_fuel_total).toFixed(2);

                // let jobTotalCosts = (ePrice) + (dPrice);
                let grossProfit = jobTotalPrice - jobProfitPlus;
                let grossProfitOverTotal = grossProfit / jobTotalPrice;
                let grossProfitPercentage = grossProfitOverTotal * 100;
                grossProfitPercentage = Math.round(grossProfitPercentage)

                jobTotals = ((jobTotals) + (jobTotalPrice));
                adminTotals = ((adminTotals) + (adminFPrice));
                driverTotals = ((driverTotals) + (dPrice));
                expTotals = ((expTotals) + (ePrice));
                profitTotals = ((profitTotals) + (jobProfit));
                grossTotals = ((grossTotals) + (grossProfitPercentage));
                // profitTotals_customer = ((profitTotals_customer) + (profitTotals_cust));
                
                expenses_approval_fuelTotal = ((expenses_approval_fuelTotal) + (parseFloat(currentJob.expenses_approval_fuel_total || 0)));
                vehicle_movementsTotal = ((vehicle_movementsTotal) + (parseFloat(currentJob.vehicle_movements) || 0));
                toll_roadTotal = ((toll_roadTotal) + (parseFloat(currentJob.toll_road)  || 0));
                waitingtimeTotal = ((waitingtimeTotal) + (parseFloat(currentJob.waitingtime) || 0));
                storageTotal = ((storageTotal) + (parseFloat(currentJob.storage)  || 0));
                breakdownTotal = ((breakdownTotal) + (parseFloat(currentJob.breakdown)  || 0));
                travelTotal = ((travelTotal) + (parseFloat(currentJob.travel)  || 0));
                car_washTotal = ((car_washTotal) + (parseFloat(currentJob.car_wash) || 0));
                partsTotal = ((partsTotal) + (parseFloat(currentJob.parts) || 0));
                transport_servicesTotal = ((transport_servicesTotal) + (parseFloat(currentJob.transport_services) || 0));
                hotelTotal = ((hotelTotal) + (parseFloat(currentJob.hotel) || 0));

                profitedRecords.push(
                        <tr key={index}>
                            <td className="job-ref-font16"><a href={joburl}>{currentJob.id}</a></td>
                            <td>{currentJob.vehicle.registration_number}</td>        
                            <td>{currentJob.customer.name}</td>        
                            <td>{currentJob.status}</td> 
                            <td>{((currentJob.driver_completed_at) ? moment(currentJob.driver_completed_at).format("DD/MM/YY") : "")}</td>             
                            <td>&pound;{jobTotalPrice.toFixed(2)}</td>
                            <td>&pound;{adminFPrice}</td>
                            <td>{currentJob.fuel_included_in_job_price === 1 ? 'YES' : 'NO'}</td>
                            <td>&pound;{dPrice.toFixed(2)}</td>
                            
                            <td className={currentJob.fuel_included_in_job_price === 1 ? "text-danger" : ""}>&pound;{expenses_approval_fuel_total}</td>
                            <td>&pound;{(currentJob.vehicle_movements/100).toFixed(2)}</td>
                            <td>&pound;{(currentJob.toll_road/100).toFixed(2)}</td>
                            <td>&pound;{(currentJob.waitingtime/100).toFixed(2)}</td>
                            <td>&pound;{(currentJob.storage/100).toFixed(2)}</td>
                            <td>&pound;{(currentJob.breakdown/100).toFixed(2)}</td>
                            <td>&pound;{(currentJob.travel/100).toFixed(2)}</td>
                            <td>&pound;{(currentJob.car_wash/100).toFixed(2)}</td>
                            <td>&pound;{(currentJob.parts/100).toFixed(2)}</td>
                            <td>&pound;{(currentJob.transport_services/100).toFixed(2)}</td>
                            <td>&pound;{(currentJob.hotel/100).toFixed(2)}</td>
                            <td>&pound;{jobProfit.toFixed(2)}</td>
                            <td>{grossProfitPercentage}%</td>
                            {/*<td>&pound;{profitTotals_cust.toFixed(2)}</td>*/}
                        </tr>
                );
                downloadableCsvDataInvoiced = downloadableCsvDataInvoiced +
                    currentJob.id+','+
                    currentJob.vehicle.registration_number+','+
                    currentJob.customer.name+','+
                    currentJob.status+','+
                    ((currentJob.driver_completed_at) ? moment(currentJob.driver_completed_at).format("DD/MM/YY") : "")+','+
                    (jobTotalPrice.toFixed(2))+','+
                    (adminFPrice)+','+
                    ((currentJob.fuel_included_in_job_price === 1) ? 'YES' : 'NO')+','+
                    (dPrice.toFixed(2))+','+
                    
                    expenses_approval_fuel_total+','+
                    ((currentJob.vehicle_movements/100).toFixed(2))+','+
                    ((currentJob.toll_road/100).toFixed(2))+','+
                    ((currentJob.waitingtime/100).toFixed(2))+','+
                    ((currentJob.storage/100).toFixed(2))+','+
                    ((currentJob.breakdown/100).toFixed(2))+','+
                    ((currentJob.travel/100).toFixed(2))+','+
                    ((currentJob.car_wash/100).toFixed(2))+','+
                    ((currentJob.parts/100).toFixed(2))+','+
                    ((currentJob.transport_services/100).toFixed(2))+','+
                    ((currentJob.hotel/100).toFixed(2))+','+
                    (jobProfit.toFixed(2))+','+
                    grossProfitPercentage+','+"\n";
                });
            profitedRecords.push(
                <tr key="last-row-total">
                    <td className="job-ref-font16 text-center" colSpan="5">Total</td>
                    <td>&pound;{jobTotals.toFixed(2)}</td>
                    <td>&pound;{adminTotals.toFixed(2)}</td>
                    <td>&nbsp;</td>
                    <td>&pound;{driverTotals.toFixed(2)}</td>
                    

                    <td>&pound;{expenses_approval_fuelTotal.toFixed(2)}</td>
                    <td>&pound;{vehicle_movementsTotal.toFixed(2)}</td>
                    <td>&pound;{(toll_roadTotal/100).toFixed(2)}</td>
                    <td>&pound;{(waitingtimeTotal/100).toFixed(2)}</td>
                    <td>&pound;{(storageTotal/100).toFixed(2)}</td>
                    <td>&pound;{(breakdownTotal/100).toFixed(2)}</td>
                    <td>&pound;{(travelTotal/100).toFixed(2)}</td>
                    <td>&pound;{(car_washTotal/100).toFixed(2)}</td>
                    <td>&pound;{(partsTotal/100).toFixed(2)}</td>
                    <td>&pound;{(transport_servicesTotal/100).toFixed(2)}</td>
                    <td>&pound;{(hotelTotal/100).toFixed(2)}</td>
                    
                    <td>&pound;{profitTotals.toFixed(2)}</td>
                    {/* <td>{grossTotals}%</td> */}
                    <td></td>
                    {/*<td>&pound;{profitTotals_customer.toFixed(2)}</td>*/}
                </tr>
            );
            downloadableCsvDataInvoiced = downloadableCsvDataInvoiced +
                                        'Total'+','+
                                        ''+','+
                                        ''+','+
                                        ''+','+
                                        ''+','+
                                        (jobTotals.toFixed(2))+','+
                                        (adminTotals.toFixed(2))+','+
                                        ''+','+
                                        (driverTotals.toFixed(2))+','+
                                        
                                        (expenses_approval_fuelTotal.toFixed(2))+','+
                                        (vehicle_movementsTotal.toFixed(2))+','+
                                        ((toll_roadTotal/100).toFixed(2))+','+
                                        ((waitingtimeTotal/100).toFixed(2))+','+
                                        ((storageTotal/100).toFixed(2))+','+
                                        ((breakdownTotal/100).toFixed(2))+','+
                                        ((travelTotal/100).toFixed(2))+','+
                                        ((car_washTotal/100).toFixed(2))+','+
                                        ((partsTotal/100).toFixed(2))+','+
                                        ((transport_servicesTotal/100).toFixed(2))+','+
                                        ((hotelTotal/100).toFixed(2))+','+
                                        (profitTotals.toFixed(2))+','+
                                        grossTotals+','+"\n";
        }else{
            profitedRecords.push(
                <tr key='no-records'><td colSpan="23" className='text-center'>No Records</td></tr>
            );
        }
        
        return (
            <div className="container-fluid">
                <div className="col-md-6">
                    <h2>Job Price Report</h2>
                    <br/>
                </div>
                
                <div className="row">
                    <div className="col-md-1">
                        <label><h5>Select Start Date:</h5></label><br/>
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleStartDateChange} selected={this.state.startDate}/>
                    </div>
                    <div className="col-md-1">
                        <label><h5>Select End Date:</h5></label><br/>
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleEndDateChange} selected={this.state.endDate}/>
                    </div>
                    <div className="col-md-3 col-sm-12">
                        <label><h5>Select Customer</h5></label><br/>
                            <div>
                                <StatefulMultiSelect
                                    options={this.state.customers}
                                    selected={selectedCustomers}
                                    onSelectedChanged={this.handleCustomerSelection}
                                        overrideStrings={{
                                            selectSomeItems: "Select Customers...",
                                            allItemsAreSelected: "All Customers are Selected",
                                            selectAll: "Select All",
                                            search: "Search Customer",
                                        }}
                                    />
                            </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-lg btn-success invoiced-btn-margin" onClick={(e) => this.handleInvoicedJobsReportGeneration(e)}>
                                   <i className="fa fa-save"></i> Generate Job Price Report
                            </button>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-primary btn-lg invoiced-btn-margin"
                                    onClick={(e) => {
                                    this.download(this.state.downloadReportName, downloadableCsvDataInvoiced);
                                  }}>
                                <i className="fa fa-download"></i> Download Job Price Report
                            </button>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <label className="alert alert-primary invoiced-btn-margin"><b>{this.state.profitReportData.length} jobs found..</b></label>
                    </div>             
                </div>
                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <div className="daily-delivered-report-tbl-scroll">
                            <table className="daily-delivered-report-tbl">
                                <thead className="sticky-top-without-zindex bg-light">
                                    <tr>
                                        <th>Job Ref</th>
                                        <th>Reg/VIN</th>
                                        <th>Customer</th>
                                        <th>Status</th>
                                        <th>Driver Completed Date</th>
                                        <th>Job Price</th>
                                        <th>Admin Fee</th>
                                        <th>Fuel Incl</th>
                                        <th>Driver Price</th>
                                        
                                        <th>Fuel</th>
                                        <th>Vehicle Movements</th>
                                        <th>Toll Road</th>
                                        <th>Waitingtime</th>
                                        <th>Storage</th>
                                        <th>Breakdown</th>
                                        <th>Travel</th>
                                        <th>Car Wash</th>
                                        <th>Parts</th>
                                        <th>Transport Services</th>
                                        <th>Hotel</th>
                                        <th>Profit</th>
                                        <th>Gross Profit %</th>
                                        {/*<th>Profit Total</th>*/}
                                    </tr>
                                </thead>
                                <tbody>
                                {this.state.isLoading ?
                                (<tr><td colSpan="23"><span className="add-loading-text">
                                        <i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :
                                    profitedRecords
                                }
                                </tbody>
                            </table>
                        </div>
                        <br/><br/><br/>
                    </div>
                </div>
            </div>
        );
    }
}
if (document.getElementById('react-component-g4-logistics-portal-profit_report')) {
    ReactDOM.render(
        <ProfitReport message_if_none = 'Nothing to report on.' />,
        document.getElementById('react-component-g4-logistics-portal-profit_report')
    );
}
